module.exports = __webpack_public_path__ + "img/W-S61.dbcfbcc9.jpg";